import { useState } from 'react';
import PropTypes from 'prop-types';
import { useAppContext, SET_FACADE } from '../context/AppContext';
import sidingButton from '../images/ui_buttons/siding_button.png';
import brickStoneButton from '../images/ui_buttons/brickStone_button.png';
import whiteSiding from '../images/ui_buttons/whiteSiding_button.png';
import tanSiding from '../images/ui_buttons/tanSiding_button.png';
import brownSiding from '../images/ui_buttons/brownSiding_button.png';
import blueSiding from '../images/ui_buttons/blueSiding_button.png';
import redBrick from '../images/ui_buttons/redBrick_button.png';
import tanBrick from '../images/ui_buttons/tanBrick_button.png';
import lightStone from '../images/ui_buttons/lightStone_button.png';
import darkStone from '../images/ui_buttons/darkStone_button.png';

const HouseMaterial = ({ selectedFacade }) => {
	const [sidingOrMasonry, setSidingOrMasonry] = useState(null);
	const { dispatch } = useAppContext();

	const handleFacadeChoice = (facadeId) => {
		console.log('HouseMaterial received click on', facadeId);
		dispatch({ type: SET_FACADE, payload: facadeId });
	};

	const handleShowInitialButtons = () => {
		setSidingOrMasonry(null);
	};

	return (
		<div>
			{sidingOrMasonry === null && (
				<>
					<h3>House Material</h3>
					<button
						className='material-image-button'
						onClick={() => setSidingOrMasonry('siding')}>
						<img src={sidingButton} alt='Siding' />
					</button>
					<button
						className='material-image-button'
						onClick={() => setSidingOrMasonry('masonry')}>
						<img src={brickStoneButton} alt='Brick/Stone' />
					</button>
				</>
			)}
			{sidingOrMasonry === 'siding' && (
				<>
					<h3>Wood Siding</h3>
					<button
						className={`material-image-button ${
							selectedFacade === 'siding_white' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('siding_white')}>
						<img src={whiteSiding} alt='White Siding' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'siding_tan' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('siding_tan')}>
						<img src={tanSiding} alt='Tan Siding' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'siding_brown' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('siding_brown')}>
						<img src={brownSiding} alt='Brown Siding' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'siding_blue' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('siding_blue')}>
						<img src={blueSiding} alt='Blue Siding' />
					</button>
					<button className='material-back-button' onClick={handleShowInitialButtons}>
						Back
					</button>
				</>
			)}
			{sidingOrMasonry === 'masonry' && (
				<>
					<h3>Brick/Stone</h3>
					<button
						className={`material-image-button ${
							selectedFacade === 'brick_red' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('brick_red')}>
						<img src={redBrick} alt='Red Brick' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'brick_tan' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('brick_tan')}>
						<img src={tanBrick} alt='Tan Brick' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'stone_light' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('stone_light')}>
						<img src={lightStone} alt='Light Stone' />
					</button>
					<button
						className={`material-image-button ${
							selectedFacade === 'stone_dark' ? 'selected' : ''
						}`}
						onClick={() => handleFacadeChoice('stone_dark')}>
						<img src={darkStone} alt='Dark Stone' />
					</button>
					<button className='material-back-button' onClick={handleShowInitialButtons}>
						Back
					</button>
				</>
			)}
		</div>
	);
};

HouseMaterial.propTypes = {
	selectedFacade: PropTypes.string
};

export default HouseMaterial;
